import { Button, Menu, MenuItem } from "@mui/material";
import "./Filter.css";
import React, { useContext, useEffect, useState } from "react";
import PrimaryButton from "../../Atoms/Buttons/Primary/PrimaryButton";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
import TextFieldInput from "../../Atoms/Inputs/TextField/TextFieldInput";
import useFetch from "../../../Hooks/useFetch";
import {
  countriesURL,
  courseListURL,
  schoolListURL,
  teacherListURL,
} from "../../../Hooks/URL";
import useFetchWhen from "../../../Hooks/useFetchWhen";
import { userContext } from "../../../Contexts/userContext";
import { grades } from "../../../Assets/grades";

function Filter({
  Gender = false,
  schools = false,
  teachers = false,
  courses = false,
  country = false,
  city = false,
  activated = false,
  terminated = false,
  Grades = false,
  setFilter,
}) {
  const { contextData, setContextData } = useContext(userContext);
  const [gender, setGender] = useState("");
  const [school, setSchool] = useState("");
  const [teacher, setTeacher] = useState("");
  const [course, setCourse] = useState("");
  const [activatedValue, setActivated] = useState("");
  const [terminatedValue, setTerminated] = useState("");
  const [cityValue, setCity] = useState("");
  const [countryValue, setCountry] = useState("");
  const [grade, setGrade] = useState("");
  const { data: countries } = useFetch(`${countriesURL}`);
  const { data: cities } = useFetchWhen(
    `${countriesURL}/${countryValue}/cities`,
    countryValue
  );

  const { data: schoolsList } = useFetchWhen(
    schoolListURL,
    contextData?.role == "admin"
  );
  const { data: teachersList } = useFetchWhen(
    contextData?.role == "admin"
      ? `${teacherListURL}?schoolId=${school}`
      : contextData?.role == "school"
      ? teacherListURL
      : "",
    (contextData?.role == "admin" && school) || contextData?.role == "school"
  );
  const { data: skillcodeTeachersList } = useFetchWhen(
    `${teacherListURL}?schoolId=${-1}`,
    contextData?.role == "admin"
  );
  const { data: coursesList } = useFetchWhen(
    contextData?.role == "admin"
      ? `${courseListURL}?schoolId=${school}`
      : contextData?.role == "school"
      ? courseListURL
      : "",
    (contextData?.role == "admin" && school) || contextData?.role == "school"
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="modernFilterContainer">
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        className="modernFilterButton"
      >
        <FilterListIcon className="filterIcon" />
        <span className="filterText">Filters</span>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        className="modernFilterMenu"
        PaperProps={{
          className: "modernFilterMenuPaper",
        }}
      >
        <div className="modernFilterArea">
          <div className="filterHeader">
            <h3 className="filterTitle">
              <FilterListIcon className="filterTitleIcon" />
              Advanced Filters
            </h3>
            <button className="closeFilterButton" onClick={handleClose}>
              <ClearIcon />
            </button>
          </div>

          <div className="filterContent">
            {country ? (
              <div className="filterItem">
                <label className="filterLabel">Country</label>
                <TextFieldInput
                  select
                  newValue={countryValue}
                  name={"country"}
                  change={(e) => setCountry(e.target.value)}
                  className="modernFilterSelect"
                  variant="outlined"
                  SelectProps={{
                    displayEmpty: true,
                  }}
                >
                  <MenuItem value="" className="modernFilterOption" disabled>
                    Choose Country
                  </MenuItem>
                  {countries?.data?.map((countryItem) => (
                    <MenuItem
                      value={countryItem?.id}
                      className="modernFilterOption"
                    >
                      {countryItem?.name}
                    </MenuItem>
                  ))}
                </TextFieldInput>
              </div>
            ) : (
              ""
            )}
            {city ? (
              <div className="filterItem">
                <label className="filterLabel">City</label>
                <TextFieldInput
                  select
                  newValue={cityValue}
                  name={"city"}
                  change={(e) => setCity(e.target.value)}
                  className="modernFilterSelect"
                  variant="outlined"
                  SelectProps={{
                    displayEmpty: true,
                  }}
                >
                  <MenuItem value="" className="modernFilterOption" disabled>
                    Choose City
                  </MenuItem>
                  {cities?.data?.map((cityItem) => (
                    <MenuItem
                      value={cityItem?.id}
                      className="modernFilterOption"
                    >
                      {cityItem?.name}
                    </MenuItem>
                  ))}
                </TextFieldInput>
              </div>
            ) : (
              ""
            )}
            {activated ? (
              <div className="filterItem">
                <label className="filterLabel">Activation Status</label>
                <TextFieldInput
                  select
                  newValue={activatedValue}
                  name={"activated"}
                  change={(e) => setActivated(e.target.value)}
                  className="modernFilterSelect"
                  variant="outlined"
                  SelectProps={{
                    displayEmpty: true,
                  }}
                >
                  <MenuItem value="" className="modernFilterOption" disabled>
                    Choose Status
                  </MenuItem>
                  <MenuItem value={"1"} className="modernFilterOption">
                    Activated
                  </MenuItem>
                  <MenuItem value={"0"} className="modernFilterOption">
                    Not Activated
                  </MenuItem>
                </TextFieldInput>
              </div>
            ) : (
              ""
            )}
            {terminated ? (
              <div className="filterItem">
                <label className="filterLabel">Termination Status</label>
                <TextFieldInput
                  select
                  newValue={terminatedValue}
                  name={"terminated"}
                  change={(e) => setTerminated(e.target.value)}
                  className="modernFilterSelect"
                  variant="outlined"
                  SelectProps={{
                    displayEmpty: true,
                  }}
                >
                  <MenuItem value="" className="modernFilterOption" disabled>
                    Choose Status
                  </MenuItem>
                  <MenuItem value={"1"} className="modernFilterOption">
                    Terminated
                  </MenuItem>
                  <MenuItem value={"0"} className="modernFilterOption">
                    Not Terminated
                  </MenuItem>
                </TextFieldInput>
              </div>
            ) : (
              ""
            )}

            {Grades ? (
              <div className="filterItem">
                <label className="filterLabel">Grade</label>
                <TextFieldInput
                  select
                  newValue={grade}
                  name={"grade"}
                  change={(e) => setGrade(e.target.value)}
                  className="modernFilterSelect"
                  variant="outlined"
                  SelectProps={{
                    displayEmpty: true,
                  }}
                >
                  <MenuItem value="" className="modernFilterOption" disabled>
                    Choose Grade
                  </MenuItem>
                  {grades.map((grade) => (
                    <MenuItem value={grade.id} className="modernFilterOption">
                      {grade.name}
                    </MenuItem>
                  ))}
                </TextFieldInput>
              </div>
            ) : (
              ""
            )}

            {Gender ? (
              <div className="filterItem">
                <label className="filterLabel">Gender</label>
                <TextFieldInput
                  select
                  newValue={gender}
                  name={"gender"}
                  change={(e) => setGender(e.target.value)}
                  className="modernFilterSelect"
                  variant="outlined"
                  SelectProps={{
                    displayEmpty: true,
                  }}
                >
                  <MenuItem value="" className="modernFilterOption" disabled>
                    Choose Gender
                  </MenuItem>
                  <MenuItem value={"male"} className="modernFilterOption">
                    Male
                  </MenuItem>
                  <MenuItem value={"female"} className="modernFilterOption">
                    Female
                  </MenuItem>
                </TextFieldInput>
              </div>
            ) : (
              ""
            )}
            {schools && contextData?.role == "admin" ? (
              <div className="filterItem">
                <label className="filterLabel">School</label>
                <TextFieldInput
                  select
                  newValue={school}
                  name={"school"}
                  change={(e) => {
                    setSchool(e.target.value);
                    setTeacher("");
                    setCourse("");
                  }}
                  className="modernFilterSelect"
                  variant="outlined"
                  SelectProps={{
                    displayEmpty: true,
                  }}
                >
                  <MenuItem value="" className="modernFilterOption" disabled>
                    Choose School
                  </MenuItem>
                  {schoolsList?.data?.map((option) => (
                    <MenuItem value={option?.id} className="modernFilterOption">
                      {option?.name}
                    </MenuItem>
                  ))}
                </TextFieldInput>
              </div>
            ) : (
              ""
            )}
            {(teachers && contextData?.role == "admin") ||
            (teachers && contextData?.role == "school") ? (
              <div className="filterItem">
                <label className="filterLabel">Teacher</label>
                <TextFieldInput
                  select
                  newValue={teacher}
                  name={"teacher"}
                  change={(e) => setTeacher(e.target.value)}
                  className="modernFilterSelect"
                  variant="outlined"
                  SelectProps={{
                    displayEmpty: true,
                  }}
                >
                  <MenuItem value="" className="modernFilterOption" disabled>
                    Choose Teacher
                  </MenuItem>
                  {teachersList?.data?.map((option) => (
                    <MenuItem value={option?.id} className="modernFilterOption">
                      {option?.name}
                    </MenuItem>
                  ))}
                  {skillcodeTeachersList?.data?.map((option) => (
                    <MenuItem value={option?.id} className="modernFilterOption">
                      {option?.name}
                    </MenuItem>
                  ))}
                </TextFieldInput>
              </div>
            ) : (
              ""
            )}
            {courses ? (
              <div className="filterItem">
                <label className="filterLabel">Program</label>
                <TextFieldInput
                  select
                  newValue={course}
                  name={"course"}
                  change={(e) => setCourse(e.target.value)}
                  className="modernFilterSelect"
                  variant="outlined"
                  SelectProps={{
                    displayEmpty: true,
                  }}
                >
                  <MenuItem value="" className="modernFilterOption" disabled>
                    Choose Program
                  </MenuItem>
                  {coursesList?.data?.map((option) => (
                    <MenuItem value={option?.id} className="modernFilterOption">
                      {option?.title}
                    </MenuItem>
                  ))}
                </TextFieldInput>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="filterActions">
            <button
              className="filterApplyButton"
              onClick={() => {
                setFilter(
                  `${school ? `&schoolId=${school}` : ""}${
                    gender ? `&gender=${gender}` : ""
                  }${teacher ? `&teacherId=${teacher}` : ""}${
                    course ? `&courseId=${course}` : ""
                  }${countryValue ? `&countryId=${countryValue}` : ""}${
                    cityValue ? `&cityId=${cityValue}` : ""
                  }${activatedValue ? `&active=${activatedValue}` : ""}${
                    terminatedValue ? `&isTerminated=${terminatedValue}` : ""
                  }${grade ? `&grade=${grade}` : ""}
                  `
                );
                handleClose();
              }}
            >
              Apply Filters
            </button>
            <button
              className="filterClearButton"
              onClick={() => {
                setGender("");
                setSchool("");
                setTeacher("");
                setCourse("");
                setCountry("");
                setCity("");
                setTerminated("");
                setActivated("");
                setGrade("");
                setFilter("");
              }}
            >
              <ClearIcon />
              Clear All
            </button>
          </div>
        </div>
      </Menu>
    </div>
  );
}

export default Filter;
